import { Box, Tab, TabList, Tabs } from "@mui/joy";
import React, { FC, Fragment } from "react";
import AddDeviceView from "./AddDeviceView";
import FogForestView from "./FogForestView";

const MainPage: React.FC<{ isAdmin: boolean }> = ({ isAdmin }) => {
  return (
    <Box
      sx={{
        width: "100%",
        mx: "auto", // margin left & right
        height: "100%",
        // my: 4, // margin top & bottom
        // py: 3, // padding top & bottom
        paddingBottom: 3,
        // px: 2, // padding left & right
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 5,
        // borderRadius: "sm",
        // boxShadow: "md",
      }}>
      {isAdmin ? <AdminView></AdminView> : <FogForestView></FogForestView>}
    </Box>
  );
};

const AdminView: FC = () => {
  const [index, setIndex] = React.useState(1);
  return (
    <Fragment>
      <Tabs size='lg' aria-label='outlined' defaultValue={1} onChange={(event, value) => setIndex(value as number)}>
        <TabList>
          <Tab variant={index === 1 ? "solid" : "plain"} color={index === 1 ? "primary" : "neutral"} value={1}>
            控制系统
          </Tab>
          <Tab variant={index === 2 ? "solid" : "plain"} color={index === 2 ? "primary" : "neutral"} value={2}>
            管理
          </Tab>
        </TabList>
      </Tabs>
      {index === 1 ? <FogForestView></FogForestView> : <AddDeviceView></AddDeviceView>}
    </Fragment>
  );
};

export default MainPage;
